// extracted by mini-css-extract-plugin
export default {"locations":"style_locations__54Odf","is-idle":"style_is-idle__QpW1h"};